import Http from '@/libs/http';

class PanelDeviceNetworkApi extends Http {
   index(deviceId, params) {
      return super.get(`panel/device/${deviceId}/network`, { params });
   }

   store(deviceId, payload, params) {
      return super.post(`panel/device/${deviceId}/network`, payload, { params });
   }

   show(deviceId, id, params) {
      return super.get(`panel/device/${deviceId}/network/${id}`, { params });
   }

   update(deviceId, id, payload, params) {
      return super.put(`panel/device/${deviceId}/network/${id}`, payload, { params });
   }

   delete(deviceId, id, params) {
      return super.delete(`panel/device/${deviceId}/network/${id}`, { params });
   }
}

export default new PanelDeviceNetworkApi();
